module.exports = __webpack_public_path__ + "img/hr-pipe-cover-south.21554ddb.png";